import { render, staticRenderFns } from "./beforeBecomeTeacher.vue?vue&type=template&id=6f058d97"
import script from "./beforeBecomeTeacher.vue?vue&type=script&lang=js"
export * from "./beforeBecomeTeacher.vue?vue&type=script&lang=js"
import style0 from "./beforeBecomeTeacher.vue?vue&type=style&index=0&id=6f058d97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports